export enum SyncState {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  VALID = 'VALID',
  WARNING = 'WARNING',
  ALERT = 'ALERT',
  ERROR = 'ERROR',
}
